
import VueClipboard from 'vue-clipboard2'
import Vue from 'vue'
import ElementUI from 'element-ui'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './css/iconfont.css'
import './css/reset.css'
import './css/iconfont.js'
import '../ttsdemo/src/css/iconfont.js'
import App from './App.vue'
import store from './store/index.js'
import VueRouter from 'vue-router'
import router from './router/index.js'
import axios from 'axios'
import less from 'less'
import * as SpeechSDK from 'microsoft-cognitiveservices-speech-sdk'
import { API_BASE_URL } from './config'
Vue.use(less)

axios.defaults.baseURL = API_BASE_URL

// 所有请求附带 Bearer，后端 readAuthTokenFromRequest 可在 query 异常时仍取到 token
axios.interceptors.request.use((config) => {
  try {
    const data = config.data
    if (typeof FormData !== 'undefined' && data instanceof FormData) return config
    const tok = store.state.user && store.state.user.token
    if (tok && !config.headers.Authorization) {
      config.headers.Authorization = 'Bearer ' + tok
    }
  } catch (e) { /* ignore */ }
  return config
})

// const setFontSize= () => {
//   const htmlDom = document.getElementsByTagName('html')[0];
//   let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
//   if (htmlWidth >= 768) {
//     htmlWidth = 1300;
//     htmlDom.style.fontSize = 16;
//   }
//   if (htmlWidth < 768) {
//     htmlDom.style.fontSize = `${100 /1200*50 }vw`
//   }
  
// };
// window.onresize = setFontSize;
// setFontSize()

Vue.prototype.$axios=axios
Vue.prototype.$sdk = SpeechSDK
Vue.config.productionTip = false

// 过滤 Element UI DatePicker 内部 placement prop 变更警告（Element UI 2.x 已知 bug）
const originalWarn = console.warn
console.warn = function (...args) {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('Avoid mutating a prop directly') && args[0].includes('"placement"')) return
  originalWarn.apply(console, args)
}
Vue.use(VueClipboard)
Vue.use(ElementUI)

// Message 默认下移，避免挡住 TopBar（约 64px 高）
const messageOffset = 72
const $message = (options) => {
  const opts = typeof options === 'string' ? { message: options } : { ...options }
  if (opts.offset == null) opts.offset = messageOffset
  return Message(opts)
}
;['success', 'warning', 'info', 'error'].forEach(type => {
  $message[type] = (options) => {
    const opts = typeof options === 'string' ? { message: options } : { ...options }
    if (opts.offset == null) opts.offset = messageOffset
    return Message[type](opts)
  }
})
Vue.prototype.$message = $message

Vue.use(VueRouter)
new Vue({
  render: h => h(App),
  store,
  router,
  axios,
  sdk: SpeechSDK
}).$mount('#app')
